import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://clump-backend-production.up.railway.app',
});

API.interceptors.request.use(config => {
  const token = localStorage.getItem('clump_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default API;
